import { LogIn } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@nesso/ui/primitives/tooltip';

type Props = {
    memberName: string;
};

// Unavailable until sign-in-as ships; aria-disabled (not `disabled`) keeps it tabbable and named.
export function ReportingPagePracticeMemberUsageTableImpersonateButton({ memberName }: Props) {
    const actionLabel = `Sign in as ${memberName}`;

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon-sm"
                        aria-disabled="true"
                        aria-label={actionLabel}
                        className="aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
                    >
                        <LogIn aria-hidden="true" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent>{actionLabel} is not available yet.</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
